import basketballImage1 from '../../images/Basketball/basketsmp8.jpeg';  // Use your image paths
import basketballImage2 from '../../images/Basketball/basketcc.jpg';
import basketballImage3 from '../../images/Basketball/basketsutd.jpg';


const topParagraph = "Definitely not a pro player — but basketball has been a big part of my life for a long time. I played for school teams from secondary school all the way through university, picking up a lot about teamwork, discipline, and perseverance along the way. I also did weekend basketball coaching for primary school kids, which was a fun side quest. If anyone's ever keen for some skills coaching, I'm open to it! These days though, my main exercise has shifted to the gym.";


const descriptions = [
    "My secondary school team at Tarakanita 2 Jakarta. I don't think I saved any high-resolution pictures, haha.",
    "My senior high school team at Canisius College Jakarta.",
    "My university team at SUTD."
];
export default function BasketballBlock() {
    const images = [basketballImage1, basketballImage2, basketballImage3];

    return (
        <section className="overflow-hidden w-full min-h-screen pt-24">
            {/* Static Top Paragraph (30% height) */}
                        <div className="h-[30%] flex items-center justify-center px-6 pt-11">
                            <p className="mx-auto max-w-4xl text-justify text-lg sm:text-xl text-muted leading-relaxed">
                                {topParagraph}
                            </p>
            </div>

                        {/* Images and Descriptions (grid) */}
                        <div className="py-10 pb-16">
                            <div className="page-container">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                    {images.map((image, index) => (
                                        <div key={index} className="rounded overflow-hidden bg-card border border-border">
                                            <img
                                                src={image}
                                                alt={`Basketball ${index + 1}`}
                                                className="w-full h-64 md:h-80 object-cover"
                                            />
                                            <div className="p-4">
                                                <p className="text-center text-sm text-muted">{descriptions[index]}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
        </section>
    );
}